export const PriorityTypes = Object.freeze({
    HIGH: 'High',
    NORMAL: 'Normal',
    LOW: 'Low',
  });
  

  export const DEFAULT_PRIORITY = PriorityTypes.NORMAL;